// @flow

import * as React from "react";
import cx from "classnames";

import styles from "./LabeledContent.scss";

type LabeledContentProps = {
  additionalContentStyles: string,
  additionalLabelStyles: string,
  children: React.Node,
  inline: boolean,
  label: string
};

const LabeledContent = ({
  additionalContentStyles,
  additionalLabelStyles,
  children,
  inline,
  label
}: LabeledContentProps) => (
  <div
    className={cx({
      [styles.wrapper]: true,
      [styles.inline]: inline
    })}
    data-testid="labeledcontent"
  >
    <div className={cx(styles.label, additionalLabelStyles, "labeled-content__label")}>{label}</div>
    <div className={cx(styles.content, additionalContentStyles, "labeled-content__content")}>
      {children}
    </div>
  </div>
);

LabeledContent.defaultProps = {
  additionalContentStyles: "",
  additionalLabelStyles: "",
  children: null,
  inline: false,
  label: ""
};

export default LabeledContent;
